import React from 'react';
import '../../style/userLayout.css';
import HeaderItem from '../headerItem';
import BreadCrumb from "../breadcrumb";
import aragLogo from '../../araglogo3@2x.png';
const AdminHeader = (props) => {
	return (
		<div className="row user-layout-header">
			<div className="row user-layout-header-row-1">
				<div style={{
					position: 'relative',
					width: '55px',
					height: 'inherit',
					display: 'inline-block',
					// marginRight: '10px',
					float: 'left'
				}}>
					<img className="user-layout-header-logo" src={aragLogo} alt=""
							 onClick={() => props.push('/')}/>
				</div>
				<HeaderItem
					title="Create User"
					href="/newUser"
				/>
				<HeaderItem
					title="View users"
					href="/users"
				/>

				<div style={{width: '60px'}} className="user-layout-header-text-div ss">
					<a href="#" onClick={(e) => {
						e.preventDefault();
						props.logout();
					}} style={{paddingLeft: '10px', borderLeft: '1px solid rgba(0, 0, 0, .25)'}}>Log off</a>
				</div>
				<div className="user-layout-header-text-div">
					<span style={{marginRight: '10px'}}>{props.username}</span>
				</div>

			</div>
			<div className="col-sm-12 burgerMenu2Setting">
				<hr className="user-layout-header-row-rule"/>
			</div>
			<div className="row user-layout-header-row-2">
				<BreadCrumb
					PathName={props.locationPathName}
					Push={props.push}
					BreadcrumbStyle="user-layout-footer-breadcrumb "
					Wrapper="user-layout-footer-breadcrumb-wrapper"/>
			</div>
		</div>
	)
};

export default AdminHeader;